<template>
    <div>
        <dl class="text-sm">
            <dt class="text-green-600 font-semibold border-b mb-1">{{model.name}}</dt>
        </dl>

        <div>
            <a v-for="subpage in model.subpages" :key="subpage.id" :href="subpage.url" target="_self">
                <div class="text-sm pt-2 underline">
                    <p>{{ subpage.name }}</p>
                </div>
            </a>
        </div>

    </div>
</template>

<script>

export default {
    props: ['model'],
    components: {

    },
    data() {
        return {
        };
    },
    methods: {
        log(obj) {
            console.log(obj);
        }
    }
};
</script>


